/* eslint-disable react/prop-types */ // TODO: add props
import { LegacyButton } from 'edrolo-style-guide';
import { Modal } from 'react-bootstrap';
import style from './DismissableModal.scss';
import { useDismissable } from '../../hooks';
import AnnouncementSVG from '../AnnouncementSVG';

const Dialog = ({ children }) => <div className={style.dialog}>{children}</div>;

const DismissableModal = ({
  children,
  buttonText,
  id,
  title,
  onDismiss,
  prerequisiteIds,
}) => {
  const [shouldShow, dismiss] = useDismissable(id, prerequisiteIds);
  const handleDismiss = () => {
    dismiss();
    onDismiss();
  };

  return (
    <Modal dialogComponentClass={Dialog} show={shouldShow}>
      <div className={style.topPanel}>
        <AnnouncementSVG className={style.announcement} />
      </div>
      <span className={style.close} onClick={handleDismiss}>
        &times;
      </span>
      <div className={style.body}>
        {title ? <h3 className={style.title}>{title}</h3> : null}
        {children}
      </div>
      <div className={style.footer}>
        <LegacyButton onClick={handleDismiss} className={style.primaryButton}>
          {buttonText}
        </LegacyButton>
      </div>
    </Modal>
  );
};

DismissableModal.defaultProps = {
  buttonText: 'Continue',
  onDismiss: () => null,
};

export default DismissableModal;
